// extracted by mini-css-extract-plugin
export default {"promo-section":"styles-module__promo-section____Rt8J","promo-section-wrapper":"styles-module__promo-section-wrapper___BO2TT"};